export default "__VITE_ASSET__CmKFWlWe__"